import { createRouter, createWebHistory } from 'vue-router'

import HomeView from './pages/home';
import ProtocolView from './pages/protocol';

const routes = [
  { path: '/', redirect: 'home' },
  { path: '/home', name: 'home', component: HomeView },
  { path: '/protocol/:target', name: 'protocol', component: ProtocolView }
]

export default createRouter({
  history: createWebHistory(),
  routes,
})
